// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-article-page {
  max-width: 53vw;
  margin: 32px auto;
  padding: 20px;
  box-sizing: border-box;
}

@media (max-width: 1159.9px) {
  .create-article-page {
    max-width: 70vw;
  }
}

@media (max-width: 768px) {
  .create-article-page {
    max-width: 85vw;
  }
}

@media (max-width: 600px) {
  .create-article-page {
    max-width: 100%;
  }
}

.distraction-less-reading .create-article-page {
  margin-left: auto;
  margin-right: auto;
  width:85%;
}

.page-header {
  margin-bottom: 20px;
}

.page-header .subtitle {
  margin: 6px 0 0 0;
  color: var(--text-secondary);
}

.article-page-form .post-form {
  padding: 0; /* use modal form styles but without modal wrapper */
}

.md-toolbar {
  display: flex;
  gap: 8px;
  align-items: center;
  background: var(--bg-secondary);
  padding: 8px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
}

.md-toolbar button {
  background: none;
  border: none;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  color: var(--text-primary);
}

.md-toolbar button:hover { background: var(--hover-bg); }

.md-toolbar-spacer { flex: 1 1; }
.md-charcount { font-size: 12px; color: var(--text-secondary); }

.md-editor { font-family: ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial; font-size: 16px; line-height: 1.6; }

.create-article-page .rich-editor {
  max-height: 70vh;
  overflow-y: auto;
}

.create-article-page .rich-editor .ProseMirror,
.create-article-page .rich-editor-textarea {
  min-height: 420px;
}

/* Preview modal that fills main-content area */
.preview-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
  padding: 24px;
}

.preview-modal {
  width: 100%;
  max-width: 1100px;
  height: 90vh;
  background: var(--bg-primary);
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(0,0,0,0.35);
  overflow: auto;
  position: relative;
  padding: 28px;
  display: flex;
  flex-direction: column;
}

.preview-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 26px;
  cursor: pointer;
  color: var(--text-secondary);
}

.preview-form-btn {
  background: var(--accent-secondary);
  color: var(--bg-secondary); /*text-color*/
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
}

.preview-form-btn:hover {
  background: var(--accent-secondary-hover);
  color: var(--text-primary);
}

.action-close-preview-btn {
  background: transparent;
  border: 1px solid var(--border-color);
  padding: 10px 24px;
  border-radius: 20px;
  cursor: pointer;
  color: var(--text-primary);
}

.action-close-preview-btn:hover {
  background: var(--hover-bg);
}

.preview-content { display: flex; flex-direction: column; gap: 16px; }
.post-preview-header h1 { margin: 0 0 6px 0; }
.preview-meta { color: var(--text-secondary); font-size: 13px; }
.preview-body { flex: 1 1; overflow: auto; padding-top: 8px; border-top: 1px solid var(--border-color); }
.preview-actions { display:flex; gap:12px; justify-content: flex-end; margin-top: 12px; }
.post-preview-header, .preview-meta, .preview-body, .preview-actions { padding: 15px; }

@media (max-width: 768px) {
  .create-article-page { padding: 12px; }
  .preview-modal { max-width: 100%; height: 100vh; padding: 16px; border-radius: 0; }

  .form-actions {
    flex-wrap: wrap;
    gap: 8px;
  }
  .form-actions-row {
    display: flex;
    gap: 8px;
    width: 100%;
  }
  .preview-form-btn,
  .action-draft-btn,
  .action-template-btn,
  .action-schedule-btn {
    flex: 1 1;
    justify-content: center;
  }
  .cancel-form-btn {
    flex: 1 1;
    justify-content: center;
  }
  .submit-form-btn {
    flex: 2 1;
    justify-content: center;
  }
  .form-actions-spacer { display: none; }
}

/* distraction-free mode */
.create-article-page.distraction-free .page-header,
.create-article-page.distraction-free .form-label,
.create-article-page.distraction-free .form-actions,
.create-article-page.distraction-free .secondary-btn.preview-form-btn {
  display: none !important;
}
.create-article-page.distraction-free .md-toolbar { display: none; }
.create-article-page.distraction-free textarea { min-height: 80vh; }
.distraction-toggle { margin-left: 12px; font-size: 12px; padding: 6px 10px; }

.cover-image-picker {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.cover-choice-btn {
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
  color: var(--text-primary);
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
}

.cover-choice-btn.selected {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 1px var(--accent-primary);
}

.custom-cover-input-wrap {
  margin-bottom: 12px;
}

.cover-status {
  margin-top: 6px;
  font-size: 13px;
}

.cover-status-loading {
  color: var(--text-secondary);
}

.cover-status-valid {
  color: #1a7f37;
}

.cover-status-invalid {
  color: #b42318;
}

.cover-thumbnails-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.cover-thumb-btn {
  width: 150px;
  height: 150px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  overflow: hidden;
  background: var(--bg-primary);
  padding: 0;
  cursor: pointer;
}

.cover-thumb-btn img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cover-thumb-btn.selected {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 2px var(--accent-primary);
}

@media (max-width: 768px) {
  .cover-thumbnails-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }

  .cover-thumb-btn {
    width: 100%;
    height: 160px;
  }
}

/* ── Autosave status indicator ────────────────────────── */
.autosave-status {
  font-size: 0.78rem;
  padding: 4px 10px;
  border-radius: 4px;
  margin-bottom: 8px;
  display: inline-block;
}
.autosave-status--saving  { color: var(--text-secondary); background: transparent; }
.autosave-status--saved   { color: var(--success-color); background: transparent; }
.autosave-status--error   { color: var(--error-color); background: var(--error-bg); }

/* form-actions row wrapper — transparent on desktop, full-width flex on mobile */
.form-actions-row {
  display: contents;
}

.action-draft-btn,
.action-schedule-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
}

.action-draft-btn {
  background: transparent;
  border: 1.5px solid var(--border-color);
  color: var(--text-secondary);
}
.action-draft-btn:hover:not(:disabled) {
  background: var(--hover-bg);
  border-color: var(--accent-primary);
  color: var(--text-primary);
}
.action-draft-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-schedule-btn {
  background: transparent;
  border: 1.5px solid var(--accent-secondary);
  color: var(--accent-secondary);
}
.action-schedule-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--accent-secondary) 12%, transparent);
  color: var(--accent-secondary);
}
.action-schedule-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-template-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
  background: transparent;
  border: 1.5px solid var(--accent-primary);
  color: var(--accent-primary);
}
.action-template-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--accent-primary) 12%, transparent);
  color: var(--accent-primary);
}
.action-template-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.locked-field-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.locked-tags-row {
  margin-bottom: 8px;
}

.locked-tag-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 999px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 600;
}

.locked-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 999px;
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

/* ── Schedule modal ──────────────────────────────────── */
.schedule-modal {
  height: auto !important;
  max-height: 88vh;
  padding: 0 !important;
}

.schedule-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--border-color);
}

.schedule-modal-header h2 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-primary);
}

.schedule-modal-header .preview-close-btn {
  position: static;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  line-height: 1;
  transition: background 0.15s;
}

.schedule-modal-header .preview-close-btn:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.schedule-modal .preview-content {
  padding: 22px 24px 24px;
  gap: 18px;
}

.schedule-modal .form-group {
  gap: 7px;
}

/* Ghost-style secondary buttons inside schedule modal */
.schedule-modal .secondary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  padding: 9px 18px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.schedule-modal .secondary-btn:hover:not(:disabled) {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.schedule-modal .secondary-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.schedule-modal .preview-actions {
  margin-top: 4px;
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
}

.schedule-modal .submit-form-btn {
  padding: 10px 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CreateArticle.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,UAAU,EAAE,oDAAoD;AAClE;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,2BAA2B,2BAA2B,EAAE;;AAExD,qBAAqB,SAAO,EAAE;AAC9B,gBAAgB,eAAe,EAAE,4BAA4B,EAAE;;AAE/D,aAAa,iGAAiG,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAEnJ;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B,EAAE,aAAa;EACzC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACrE,0BAA0B,iBAAiB,EAAE;AAC7C,gBAAgB,4BAA4B,EAAE,eAAe,EAAE;AAC/D,gBAAgB,SAAO,EAAE,cAAc,EAAE,gBAAgB,EAAE,yCAAyC,EAAE;AACtG,mBAAmB,YAAY,EAAE,QAAQ,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;AACxF,uEAAuE,aAAa,EAAE;;AAEtF;EACE,uBAAuB,aAAa,EAAE;EACtC,iBAAiB,eAAe,EAAE,aAAa,EAAE,aAAa,EAAE,gBAAgB,EAAE;;EAElF;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;IACR,WAAW;EACb;EACA;;;;IAIE,SAAO;IACP,uBAAuB;EACzB;EACA;IACE,SAAO;IACP,uBAAuB;EACzB;EACA;IACE,SAAO;IACP,uBAAuB;EACzB;EACA,uBAAuB,aAAa,EAAE;AACxC;;AAEA,0BAA0B;AAC1B;;;;EAIE,wBAAwB;AAC1B;AACA,oDAAoD,aAAa,EAAE;AACnE,iDAAiD,gBAAgB,EAAE;AACnE,sBAAsB,iBAAiB,EAAE,eAAe,EAAE,iBAAiB,EAAE;;AAE7E;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE;IACE,4DAA4D;EAC9D;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;AACA,4BAA4B,4BAA4B,EAAE,uBAAuB,EAAE;AACnF,4BAA4B,2BAA2B,EAAE,uBAAuB,EAAE;AAClF,4BAA4B,yBAAyB,EAAE,2BAA2B,EAAE;;AAEpF,iFAAiF;AACjF;EACE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,8BAA8B;AAChC;AACA;EACE,wEAAwE;EACxE,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;EAC1D,uBAAuB;EACvB,yCAAyC;EACzC,4BAA4B;AAC9B;AACA;EACE,sEAAsE;EACtE,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,2DAA2D;AAC3D;EACE,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".create-article-page {\r\n  max-width: 53vw;\r\n  margin: 32px auto;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n@media (max-width: 1159.9px) {\r\n  .create-article-page {\r\n    max-width: 70vw;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .create-article-page {\r\n    max-width: 85vw;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .create-article-page {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n.distraction-less-reading .create-article-page {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  width:85%;\r\n}\r\n\r\n.page-header {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.page-header .subtitle {\r\n  margin: 6px 0 0 0;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.article-page-form .post-form {\r\n  padding: 0; /* use modal form styles but without modal wrapper */\r\n}\r\n\r\n.md-toolbar {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  background: var(--bg-secondary);\r\n  padding: 8px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n}\r\n\r\n.md-toolbar button {\r\n  background: none;\r\n  border: none;\r\n  padding: 6px 8px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.md-toolbar button:hover { background: var(--hover-bg); }\r\n\r\n.md-toolbar-spacer { flex: 1; }\r\n.md-charcount { font-size: 12px; color: var(--text-secondary); }\r\n\r\n.md-editor { font-family: ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial; font-size: 16px; line-height: 1.6; }\r\n\r\n.create-article-page .rich-editor {\r\n  max-height: 70vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.create-article-page .rich-editor .ProseMirror,\r\n.create-article-page .rich-editor-textarea {\r\n  min-height: 420px;\r\n}\r\n\r\n/* Preview modal that fills main-content area */\r\n.preview-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,0.45);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1200;\r\n  padding: 24px;\r\n}\r\n\r\n.preview-modal {\r\n  width: 100%;\r\n  max-width: 1100px;\r\n  height: 90vh;\r\n  background: var(--bg-primary);\r\n  border-radius: 12px;\r\n  box-shadow: 0 16px 40px rgba(0,0,0,0.35);\r\n  overflow: auto;\r\n  position: relative;\r\n  padding: 28px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.preview-close-btn {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 12px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 26px;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.preview-form-btn {\r\n  background: var(--accent-secondary);\r\n  color: var(--bg-secondary); /*text-color*/\r\n  border: none;\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.preview-form-btn:hover {\r\n  background: var(--accent-secondary-hover);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.action-close-preview-btn {\r\n  background: transparent;\r\n  border: 1px solid var(--border-color);\r\n  padding: 10px 24px;\r\n  border-radius: 20px;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.action-close-preview-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.preview-content { display: flex; flex-direction: column; gap: 16px; }\r\n.post-preview-header h1 { margin: 0 0 6px 0; }\r\n.preview-meta { color: var(--text-secondary); font-size: 13px; }\r\n.preview-body { flex: 1; overflow: auto; padding-top: 8px; border-top: 1px solid var(--border-color); }\r\n.preview-actions { display:flex; gap:12px; justify-content: flex-end; margin-top: 12px; }\r\n.post-preview-header, .preview-meta, .preview-body, .preview-actions { padding: 15px; }\r\n\r\n@media (max-width: 768px) {\r\n  .create-article-page { padding: 12px; }\r\n  .preview-modal { max-width: 100%; height: 100vh; padding: 16px; border-radius: 0; }\r\n\r\n  .form-actions {\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n  }\r\n  .form-actions-row {\r\n    display: flex;\r\n    gap: 8px;\r\n    width: 100%;\r\n  }\r\n  .preview-form-btn,\r\n  .action-draft-btn,\r\n  .action-template-btn,\r\n  .action-schedule-btn {\r\n    flex: 1;\r\n    justify-content: center;\r\n  }\r\n  .cancel-form-btn {\r\n    flex: 1;\r\n    justify-content: center;\r\n  }\r\n  .submit-form-btn {\r\n    flex: 2;\r\n    justify-content: center;\r\n  }\r\n  .form-actions-spacer { display: none; }\r\n}\r\n\r\n/* distraction-free mode */\r\n.create-article-page.distraction-free .page-header,\r\n.create-article-page.distraction-free .form-label,\r\n.create-article-page.distraction-free .form-actions,\r\n.create-article-page.distraction-free .secondary-btn.preview-form-btn {\r\n  display: none !important;\r\n}\r\n.create-article-page.distraction-free .md-toolbar { display: none; }\r\n.create-article-page.distraction-free textarea { min-height: 80vh; }\r\n.distraction-toggle { margin-left: 12px; font-size: 12px; padding: 6px 10px; }\r\n\r\n.cover-image-picker {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.cover-choice-btn {\r\n  border: 1px solid var(--border-color);\r\n  background: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  border-radius: 8px;\r\n  padding: 8px 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.cover-choice-btn.selected {\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 0 0 1px var(--accent-primary);\r\n}\r\n\r\n.custom-cover-input-wrap {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.cover-status {\r\n  margin-top: 6px;\r\n  font-size: 13px;\r\n}\r\n\r\n.cover-status-loading {\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.cover-status-valid {\r\n  color: #1a7f37;\r\n}\r\n\r\n.cover-status-invalid {\r\n  color: #b42318;\r\n}\r\n\r\n.cover-thumbnails-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\r\n  gap: 10px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.cover-thumb-btn {\r\n  width: 150px;\r\n  height: 150px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  background: var(--bg-primary);\r\n  padding: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.cover-thumb-btn img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n.cover-thumb-btn.selected {\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 0 0 2px var(--accent-primary);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .cover-thumbnails-grid {\r\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\r\n  }\r\n\r\n  .cover-thumb-btn {\r\n    width: 100%;\r\n    height: 160px;\r\n  }\r\n}\r\n\r\n/* ── Autosave status indicator ────────────────────────── */\r\n.autosave-status {\r\n  font-size: 0.78rem;\r\n  padding: 4px 10px;\r\n  border-radius: 4px;\r\n  margin-bottom: 8px;\r\n  display: inline-block;\r\n}\r\n.autosave-status--saving  { color: var(--text-secondary); background: transparent; }\r\n.autosave-status--saved   { color: var(--success-color); background: transparent; }\r\n.autosave-status--error   { color: var(--error-color); background: var(--error-bg); }\r\n\r\n/* form-actions row wrapper — transparent on desktop, full-width flex on mobile */\r\n.form-actions-row {\r\n  display: contents;\r\n}\r\n\r\n.action-draft-btn,\r\n.action-schedule-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 9px 18px;\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.action-draft-btn {\r\n  background: transparent;\r\n  border: 1.5px solid var(--border-color);\r\n  color: var(--text-secondary);\r\n}\r\n.action-draft-btn:hover:not(:disabled) {\r\n  background: var(--hover-bg);\r\n  border-color: var(--accent-primary);\r\n  color: var(--text-primary);\r\n}\r\n.action-draft-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.action-schedule-btn {\r\n  background: transparent;\r\n  border: 1.5px solid var(--accent-secondary);\r\n  color: var(--accent-secondary);\r\n}\r\n.action-schedule-btn:hover:not(:disabled) {\r\n  background: color-mix(in srgb, var(--accent-secondary) 12%, transparent);\r\n  color: var(--accent-secondary);\r\n}\r\n.action-schedule-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.action-template-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 9px 18px;\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s, border-color 0.2s;\r\n  background: transparent;\r\n  border: 1.5px solid var(--accent-primary);\r\n  color: var(--accent-primary);\r\n}\r\n.action-template-btn:hover:not(:disabled) {\r\n  background: color-mix(in srgb, var(--accent-primary) 12%, transparent);\r\n  color: var(--accent-primary);\r\n}\r\n.action-template-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.locked-field-display {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  padding: 10px 12px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.locked-tags-row {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.locked-tag-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 10px;\r\n  border-radius: 999px;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  color: var(--text-primary);\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.locked-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 2px 7px;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--border-color);\r\n  background: var(--bg-primary);\r\n  color: var(--text-secondary);\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n/* ── Schedule modal ──────────────────────────────────── */\r\n.schedule-modal {\r\n  height: auto !important;\r\n  max-height: 88vh;\r\n  padding: 0 !important;\r\n}\r\n\r\n.schedule-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 20px 24px 16px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.schedule-modal-header h2 {\r\n  margin: 0;\r\n  font-size: 1.05rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.schedule-modal-header .preview-close-btn {\r\n  position: static;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 22px;\r\n  line-height: 1;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.schedule-modal-header .preview-close-btn:hover {\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.schedule-modal .preview-content {\r\n  padding: 22px 24px 24px;\r\n  gap: 18px;\r\n}\r\n\r\n.schedule-modal .form-group {\r\n  gap: 7px;\r\n}\r\n\r\n/* Ghost-style secondary buttons inside schedule modal */\r\n.schedule-modal .secondary-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  border: 1px solid var(--border-color);\r\n  padding: 9px 18px;\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s, color 0.15s;\r\n}\r\n\r\n.schedule-modal .secondary-btn:hover:not(:disabled) {\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.schedule-modal .secondary-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.schedule-modal .preview-actions {\r\n  margin-top: 4px;\r\n  padding-top: 16px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.schedule-modal .submit-form-btn {\r\n  padding: 10px 24px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
